module.exports = {
  "country": "PT",
  "artist": "Dora",
  "song": "Nao sejas mau para mim",
  "year": "1986",
  "place": "14",
  "spotify": "5wkiisYIU6gHErmsfbdgI5"
};